import { getTodayScintilla } from "@/data/scintille";
import { Sparkles } from "lucide-react";

export default function ScintillaCard() {
  const { quote, author } = getTodayScintilla();
  const today = new Date().toLocaleDateString("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <section
      data-testid="scintilla-card"
      className="bg-[#f9f5ef] rounded-[18px] p-6 border border-[#ede7df] shadow-[0_8px_24px_-16px_rgba(46,40,32,0.25)] relative overflow-hidden"
    >
      {/* Decorative amber top accent */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-[#e07818]" />

      <div className="flex items-center gap-2 mb-3">
        <Sparkles strokeWidth={1.5} className="w-4 h-4 text-[#e07818]" />
        <p className="font-body font-light text-[10px] tracking-[0.4em] uppercase text-[#e07818]">
          Scintilla del Giorno
        </p>
      </div>

      {/* Decorative amber line */}
      <div className="flex items-center gap-3 mb-4" aria-hidden="true">
        <span className="h-px flex-1 bg-gradient-to-r from-[#e07818]/0 via-[#e07818]/70 to-[#e07818]/0" />
      </div>

      <p
        data-testid="scintilla-quote"
        className="font-serif-display italic font-light text-[20px] leading-[1.4] text-[#2e2820]"
      >
        “{quote}”
      </p>
      <p
        data-testid="scintilla-author"
        className="font-body font-light text-[11px] tracking-[0.3em] uppercase text-[#7a6f65] mt-4"
      >
        — {author}
      </p>
      <p className="font-body font-light text-[11px] text-[#7a6f65]/80 mt-3 capitalize">
        {today}
      </p>
    </section>
  );
}
